import axios from "axios";

const updateUrlFlirVideo = async (flirVideoId, url) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.patch(
      `${process.env.REACT_APP_URL_BACKEND}api/v1/flir-video/${flirVideoId}`,
      {
        urlVideo: url,
      },
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    const data = await res.data;
    return data;
  } catch (error) {
    return error;
  }
};

export default updateUrlFlirVideo;
